<template>
  <v-app>
    <v-app-bar app color="#262D46" dark fixed height="48">
      <v-row class="flex-nowrap no-gutters">
        <v-col class="d-flex flex-row justify-start">
          <v-btn v-if="showBack" class="btnBack" dark data-ktznta="30" icon @click="back()">
            <v-icon large>mdi-chevron-left</v-icon>
          </v-btn>
        </v-col>

        <v-col class="d-flex flex-row align-center justify-center">
          <v-toolbar-title v-text="title" />
        </v-col>

        <v-col class="d-flex flex-row justify-end">
          <v-btn v-if="showEditGroup" class="btnEditGroup" dark text @click="editGroup()">
            {{ $t("edit") }}
          </v-btn>
          <subsc-re-connect-component v-if="!isGuest"></subsc-re-connect-component>
          <notice-unread-component></notice-unread-component>
          <connectivity-indicator-component></connectivity-indicator-component>
        </v-col>
      </v-row>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import { createComponent, value } from "vue-function-api";
import { i18n } from "../plugins/i18n";
import store from "@/store";
import { ComponentMutation } from "@/framework/store/component/types";
import NoticeUnreadComponent from "../components/NoticeUnread.vue";
import ConnectivityIndicatorComponent from "../components/ConnectivityIndicator.vue";
import { MembersEditMode } from "../constants/group";
import SubscReConnectComponent from "../components/SubscReConnect.vue";

export default createComponent({
  components: {
    NoticeUnreadComponent,
    SubscReConnectComponent,
    ConnectivityIndicatorComponent,
  },
  setup(props, context) {
    const $router = context.root.$router;
    const $route = context.root.$route;

    const isGuest = !!store.getters.user && store.getters.user.userType === "biz_guest";
    const title = value("");
    let backTo = "";
    let preBackMethod = () => {};
    const showEditGroup = value(false);
    const showBack = value(true);

    store.subscribe((mutation, state) => {
      if (mutation.type !== ComponentMutation.SET_NAVIGATION) return;
      title.value = mutation.payload.title;
      backTo = mutation.payload.backTo;
      if (mutation.payload.preBackMethod) {
        preBackMethod = mutation.payload.preBackMethod;
      } else {
        preBackMethod = () => {};
      }

      if (mutation.payload.showBack != null) {
        showBack.value = mutation.payload.showBack;
      }

      showEditGroup.value = mutation.payload.editGroup;
    });

    const back = async () => {
      const res = await preBackMethod();
      if (typeof res === "undefined" || res) {
        if (backTo) {
          $router.replace(backTo);
        } else {
          $router.back();
        }
      }
    };

    const editGroup = () => {
      $router.push({
        path: `/${i18n.locale}/group/members/edit/${$route.params.groupId}`,
        query: { mode: MembersEditMode.Edit },
      });
    };

    return {
      isGuest,
      title,
      back,
      showEditGroup,
      editGroup,
      showBack,
    };
  },
});
</script>

<style scoped>
.btnBack {
  position: fixed;
}

.btnEditGroup {
  font-size: 1em;
}
</style>
